export default {
  post: 'Enregistré avec succès',
  put: 'Mis à jour avec succès',
  patch: 'Mis à jour avec succès',
  delete: 'Supprimé avec succès',
  passwordReset: 'Vous allez recevoir un email avec un lien pour réinitialiser votre mot de passe.',
};
